<template>
  <div>{{ msg }}</div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$i18n.t("Satisfaction page")
    };
  },
  data() {
    return {
      msg: this.$i18n.t("Welcome to satisfaction page!!")
    };
  }
};
</script>

<style lang="stylus" scoped></style>
